import React from "react";
import { getCoverageWeeks } from "../../utils/reportUtils";

const CoverageStrip = ({ result, today }) => {
  if (!result) {
    return null;
  }

  const cells = getCoverageWeeks(result, today);

  return (
    <span className="strip">
      {cells.map((cell, index) => (
        <i key={index} className={cell.className} title={cell.title}></i>
      ))}
    </span>
  );
};

export default CoverageStrip;
